(function () {
  var ATTRIBUTION_KEY = 'algolia_search_attribution';
  var CART_ITEMS_KEY = 'algolia_cart_attributions';
  var ATTRIBUTION_TTL = 1800000;
  var QUERY_ID_TTL = 3600000;

  function getAttribution() {
    try {
      var raw = localStorage.getItem(ATTRIBUTION_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (Date.now() - data.timestamp > ATTRIBUTION_TTL) {
        localStorage.removeItem(ATTRIBUTION_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function addCartAttribution(variantId, attribution) {
    try {
      var raw = localStorage.getItem(CART_ITEMS_KEY);
      var items = raw ? JSON.parse(raw) : {};
      items[String(variantId)] = {
        queryID: attribution.queryID,
        objectID: attribution.objectID,
        indexName: attribution.indexName,
        timestamp: Date.now()
      };
      localStorage.setItem(CART_ITEMS_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function getCartAttributions() {
    try {
      var raw = localStorage.getItem(CART_ITEMS_KEY);
      if (!raw) return {};
      var items = JSON.parse(raw);
      var now = Date.now();
      var valid = {};
      for (var vid in items) {
        if (items[vid].timestamp && (now - items[vid].timestamp) < QUERY_ID_TTL) {
          valid[vid] = items[vid];
        }
      }
      return valid;
    } catch (e) {
      return {};
    }
  }

  function clearCartAttributions() {
    try { localStorage.removeItem(CART_ITEMS_KEY); } catch (e) {}
  }

  document.addEventListener('on:cart:add', function (e) {
    if (typeof window.aa !== 'function') return;

    var detail = e.detail || {};
    var variantId = detail.variantId;
    var attribution = getAttribution();

    if (!attribution || !attribution.queryID || !attribution.objectID) {
      return;
    }

    aa('addedToCartObjectIDsAfterSearch', {
      index: attribution.indexName,
      eventName: 'Product Added to Cart from Search',
      queryID: attribution.queryID,
      objectIDs: [attribution.objectID]
    });

    if (variantId) {
      addCartAttribution(variantId, attribution);
    }

    localStorage.removeItem(ATTRIBUTION_KEY);
  });

  
})();
